export const SET_LISTING = 'SET_LISTING'
export const SET_STAY_ITINERARY = 'SET_STAY_ITINERARY'
export const ROOM_ALTERNATES = 'ROOM_ALTERNATES'
export const SET_ROOM_ALTERNATES = 'SET_ROOM_ALTERNATES'
export const RAW_ROOM_ALTERNATES = 'RAW_ROOM_ALTERNATES'
export const SET_RAW_ROOM_ALTERNATES = 'SET_RAW_ROOM_ALTERNATES'
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY'
